module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt-BR":{"expiresIn":{"title":"Tempo até expirar","hours":" - | 1 hora | {count} horas","minutes":" - | 1 minuto | {count} minutos","append":"e"}},"en-US":{"expiresIn":{"title":"Time until expire","hours":" - | 1 hour | {count} hours","minutes":" - | 1 minute | {count} minutes","append":"and"}}}')
  delete Component.options._Ctor
}
